import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./components/ui/tooltip"
import { InfoIcon } from 'lucide-react';

export const ZugferdInfo = ({ info, details }) => {
  return (
    <div className="flex items-start gap-2">
      <p className="text-sm text-gray-600">{info}</p>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <InfoIcon className="h-4 w-4 text-gray-400 cursor-help mt-0.5" />
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">
            <p className="text-sm">{details}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default ZugferdInfo;